export default "__VITE_ASSET__6WGfYp1u__"